module.exports = __webpack_public_path__ + "static/media/tab-gear-icon.97a5f769.png";